import React, { useEffect, useState } from "react";
import api from "../services/api"; // Your API service

const SupportRequestPage = () => {
    const [formData, setFormData] = useState({
        category: "",
        subject: "",
        message: "",
    });

    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch past support requests
    useEffect(() => {
        const fetchRequests = async () => {
            try {
                const response = await api.get("/support-requests");
                setRequests(response.data);
            } catch (err) {
                console.error("Error fetching requests:", err);
                setError("Failed to load support requests.");
            } finally {
                setLoading(false);
            }
        };

        fetchRequests();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        try {
            const response = await api.post("/support-request", formData);
            setSuccess(response.data.message);

            // Refresh the request list immediately after submitting
            const updatedRequests = await api.get("/support-requests");
            setRequests(updatedRequests.data);

            // Reset form fields
            setFormData({ category: "", subject: "", message: "" });
        } catch (err) {
            console.error("Error submitting request:", err);
            setError("Failed to submit request.");
        }
    };

    return (
        <div style={styles.container}>
            <div style={styles.leftPanel}>
                <h5>Submit a Support Request</h5>

                {success && <p style={styles.success}>{success}</p>}
                {error && <p style={styles.error}>{error}</p>}

                <form onSubmit={handleSubmit} style={styles.form}>
                    <label style={styles.label}>Category:</label>
                    <select name="category" value={formData.category} onChange={handleChange} required>
                        <option value="">Select Category</option>
                        <option value="Technical Issue">Technical Issue</option>
                        <option value="Billing">Billing</option>
                        <option value="Payroll Processing">Payroll Processing</option>
                        <option value="Tax Questions">Tax Questions</option>
                        <option value="Other">Other</option>
                    </select>

                    <label style={styles.label}>Subject:</label>
                    <input type="text" name="subject" value={formData.subject} onChange={handleChange} required />

                    <label style={styles.label}>Message:</label>
                    <textarea style={styles.text} name="message" value={formData.message} onChange={handleChange} required />

                    <button style={styles.button} type="submit">Submit Request</button>
                </form>
            </div>

            <div style={styles.rightPanel}>
                <h5>My Support Requests</h5>

                {loading ? (
                    <p>Loading requests...</p>
                ) : requests.length === 0 ? (
                    <p>No support requests submitted yet.</p>
                ) : (
                    <table style={styles.table}>
                        <thead style={styles.tableHead}>
                            <tr>
                                <th>Category</th>
                                <th>Subject</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>
                        </thead>
                        <tbody style={styles.tableBody}>
                            {requests.map((request) => (
                                <tr key={request.id}>
                                    <td>{request.category}</td>
                                    <td>{request.subject}</td>
                                    <td style={styles.status(request.status)}>{request.status}</td>
                                    <td>{new Date(request.created_at).toLocaleDateString()}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

// Inline Styles
const styles = {
    container: {
        display: "flex",
        maxWidth: "1200px",
        margin: "50px auto",
        fontFamily: "Arial, sans-serif",
    },
    leftPanel: {
        flex: 1,
        padding: "25px",
        borderRight: "1px solid #ddd",
        backgroundColor: "#f9f9f9",
        maxWidth: "350px",
        textAlign:'center',
        fontSize:"14px",
        marginTop:"15px",
        
        

    },
    label: {
        marginTop:"15px",
    },
    rightPanel: {
        textAlign:'center',
        flex: 1,
        padding: "20px",
    },
    tableHead: {
    textAlign: "center",
    paddingBottom: "px",  // Adds spacing below all <th> elements
    },

    tableBody: {
        textAlign:'center',
        fontSize:'14px',

    },
    button:{
        backgroundColor:" #1e87dc",
        marginTop:"20px",
        color:'white',

    },
    text:{
        height: "80px",

    },
    form: {
        display: "flex",
        flexDirection: "column",
    },
    error: {
        color: "red",
        fontSize: "14px",
        marginBottom: "10px",
    },
    success: {
        color: "green",
        fontSize: "14px",
        marginBottom: "10px",
    },
    table: {
        width: "100%",
        marginTop: "50px",
        borderCollapse: "separate", // Must be "separate" for border-spacing to work
        borderSpacing: "0 10px",
    },
    tableHeader: {
        backgroundColor: "#007bff",
        color: "white",
    },
    status: (status) => ({
        color: status === "Resolved" ? "green" : status === "In Progress" ? "orange" : "red",
        fontWeight: "bold",
    }),
};

export default SupportRequestPage;

